import { SingularInvoice } from '../../../../components/service/subscription/invoice/SingularInvoice';
export const SingularSubscriptionInvoicePageView = () => {
  return <SingularInvoice data-sentry-element="SingularInvoice" data-sentry-component="SingularSubscriptionInvoicePageView" data-sentry-source-file="singular-subscription-invoice.tsx" />;
};